export default __webpack_public_path__ + "static/media/kg.de059741.svg";